class TooltipService {
  onTooltipOpen?: (x: number, y: number, xValue: any) => void;
  onTooltipClose?: () => void;

  renderTooltip(x, y, xValue) {
    if (this.onTooltipOpen) {
      this.onTooltipOpen(x, y, xValue);
    }
  }
  clearTooltip() {
    if (this.onTooltipClose) {
      this.onTooltipClose();
    }
  }
}

export default TooltipService;
